import {Routes, Route} from 'react-router-dom'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Card from './pages/Card/Card'
import NotFound from './pages/NotFound/NotFound'



export default function RoutesList()
    {
        return(
            <Routes>
                <Route path="/about" element={<About/>} />
                <Route path="/" element={<Home/>} />
                <Route path="/Card/:id" element={<Card />} />
                <Route path="*" element={<NotFound/>} />
            </Routes>
        )
    }
